module.exports = __webpack_public_path__ + "static/img/lb_img_1.42a6b3ff.png";